import { GlLink } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'TableOfContentsHeading',
    components: {
        GlLink
    },
    props: {
        heading: {
            type: Object,
            required: true
        }
    }
};
